const now: { (): number; last?: number } = () => {
  const time = Date.now();
  const last = now.last || time;
  // eslint-disable-next-line no-return-assign
  return (now.last = time > last ? time : last + 1);
};

interface I {
  (prefix?: number): number;
  (prefix: string): string;
}

export const getUniqId: I = (prefix?: any) => (prefix ? prefix + now() : now());
